<div class="container" [ngClass]="{
    'available-soon': isNotAvailable() || (isOpenAccess() && isPreorder()),
  }">
  <ng-container [ngTemplateOutlet]="getTemplate()"> </ng-container>
</div>

<ng-template #notAvailable>
  <div class="btn-spacer">
    <ng-container [ngTemplateOutlet]="info"></ng-container>
  </div>
  <div class="label mono tiny pointer available-soon">
    {{
    (isOutOfPrint() ? "BOOK.info-outOfPrint" : "BOOK.info-4wk-12mo")
    | translate
    }}
  </div>
</ng-template>

<ng-template #preorderInfo>
  @if (isNorthAmericanUser() && !isElectronic()) {
  <div class="label mono tiny pointer">
    {{ "BOOK.preorder_on_indiepubs" | translate }}
  </div>
  } @else {
  <div class="label mono tiny pointer" (click)="preorderPopup.show = true">
    {{ "BOOK.preorder_on_dgb" | translate }}
    <span inlineSVG="img/icon-info-small.svg"></span>
    <!-- {{ "BOOK.availableOn" | translate }}
      {{ languageService.formatDate(productSupply.publishingDate, false) }} -->
    <!-- <span inlineSVG="img/icon-info-small.svg"></span> -->
  </div>
  }

</ng-template>

<ng-template #printBook>
  <div class="btn" (click)="onPurchaseButtonClick()">
    <div class="icon"
      [inlineSVG]="purchaseButtonState() === 'default' ? 'img/add-to-cart.svg' : 'img/icon-redirect.svg'"></div>
    <ng-container [ngTemplateOutlet]="info"></ng-container>
  </div>

  @if (addToCartFailed()) {
  <div class="label mono tiny error">
    {{ "BOOK.add_to_cart_failed" | translate }}
  </div>
  }

  <ng-container [ngTemplateOutlet]="isPreorder() ? preorderInfo : printInfo"></ng-container>

  <!-- printInfo only renders for non-preorder books (see outlet above),
       so purchaseButtonState() here can only be 'indiepubs' or 'default'. -->
  <ng-template #printInfo>
    @switch (true) {
    @case (purchaseButtonState() === 'indiepubs') {
    <div class="label mono tiny pointer">
      {{ "BOOK.buy_on_indiepubs" | translate }}
    </div>
    }
    @case (isElectronic() && isNorthAmericanUser()) {
    <div class="label mono tiny pointer" (click)="electronicAccessPopup.show = true">
      {{ "BOOK.electronic_access_info" | translate }}
    </div>
    }
    @case (!isElectronic()) {
    <div class="label mono tiny pointer" (click)="freeShippingPopup.show = true">
      {{ "BOOK.free_shipping" | translate }}
      <span inlineSVG="img/icon-info-small.svg"></span>
    </div>
    }
    }
  </ng-template>
</ng-template>

<ng-template #openAccessBook>
  <div class="btn" (click)="downloadPDF()">
    <div class="icon" inlineSVG="img/download-ebook.svg"></div>
    <ng-container [ngTemplateOutlet]="info"></ng-container>
  </div>
  <ng-container [ngTemplateOutlet]="isPreorder() ? preorderInfo : openAccessInfo"></ng-container>
  <ng-template #openAccessInfo>
    <div class="label mono tiny pointer" (click)="ccPopup.show = true">
      {{ "BOOK.view_license" | translate }}
      <span inlineSVG="img/icon-info-small.svg"></span>
    </div>
  </ng-template>
</ng-template>

<ng-template #info>
  <div class="info">
    <div class="format">
      {{ "BOOK.format_" + productSupply.format.toLowerCase() | translate }}
    </div>
    <div class="price">
      {{ priceService.getPriceString(productSupply) }}
    </div>
  </div>
</ng-template>

<app-popup #ccPopup titleKey="BOOK.view_license_headline" [icon]="
    productSupply.creativeCommonsLicense
      ? ccLicenseTypeIcon[productSupply.creativeCommonsLicense]
      : ''
  ">
  <div class="mono small">
    @if (productSupply.creativeCommonsLicense) {
    <div class="pre" [innerHTML]="
          ccLicenseTypeTranslation[productSupply.creativeCommonsLicense]
            | translate
        "></div>
    }
  </div>
</app-popup>

<app-popup #preorderPopup>
  <div class="mono small">
    <div class="pre" [innerHTML]="'BOOK.preorder_on_dgb_infotext' | translate"></div>
  </div>
</app-popup>

<app-popup #freeShippingPopup titleKey="BOOK.free_shipping_headline" icon="img/icon-shipping-info.svg">
  <div class="mono small pre" [innerHTML]="'BOOK.free_shipping_infotext' | translate"></div>
</app-popup>

<app-popup #electronicAccessPopup titleKey="BOOK.electronic_access_headline">
  <div class="mono small pre" [innerHTML]="'BOOK.electronic_access_infotext' | translate"></div>
</app-popup>